/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
/**
 * Middleware Options used for component telemetry
 *
 * @export
 * @class ComponentMiddlewareOptions
 * @implements {MiddlewareOptions}
 */
export class ComponentMiddlewareOptions {
    constructor(component) {
        if (typeof component === 'string') {
            this.componentName = component;
        }
        else {
            this.componentName = component.tagName.toLowerCase();
        }
    }
}
//# sourceMappingURL=ComponentMiddlewareOptions.js.map